import React, { Component } from 'react'
import styled from 'styled-components'
import { PageWrapper, XMText, Header, XXLText, DefaultText } from '../components'
const Ul = styled.ul`
  padding-left: 16px;
  word-break: break-word;
  & > li {
    padding-bottom: 10px;
  }
  a {
    color: #2497c1;
    font-size: 14px;
  }
`
const Anchor = styled.a`
  color: #2497c1;
  font-size: 14px;
`
class PrivacyPolicy extends Component {
  state = {}

  render() {
    const native = this.props.location.pathname.indexOf('native') > -1
    return (
      <React.Fragment>
        {!native && (
          <Header
            title={'Privacy Policy'}
            icon="arrowBack"
            onClickBack={() => this.props.history.replace('/user-profile')}
            color="#fff"
          />
        )}
        <PageWrapper viewPadding={native ? '5.4% 3.9% 6%' : '22.4% 3.9% 6%'} height="auto">
          <XXLText textAlign="left" color="#124b5f">
            Privacy Policy
          </XXLText>
          <XMText color="#9a9a9a" padding="0 0 10px 0">
            Effective date: December 21, 2018
          </XMText>
          <XMText color="#777777" padding="0 0 10px 0">
            GreenChoice, PBC (“us”, “we”, or “our”) operates the{' '}
            <Anchor href="https://www.greenchoicenow.com" target="_blank" rel="noopener noreferrer">
              https://www.greenchoicenow.com
            </Anchor>{' '}
            website and the GreenChoice mobile application (hereinafter referred to as the “Service”).
          </XMText>
          <XMText color="#777777" padding="0 0 10px 0">
            This page informs you of our policies regarding the collection, use and disclosure of personal data when you
            use our Service and the choices you have associated with that data.
          </XMText>
          <XMText color="#777777" padding="0 0 10px 0">
            We use your data to provide and improve the Service. By using the Service, you agree to the collection and
            use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the
            terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.
          </XMText>
          <DefaultText color="#124b5f">Definitions</DefaultText>
          <Ul>
            <li>
              <XMText fontWeight="600" padding="0 0 6px 0" color="#777777">
                Service
              </XMText>
              <XMText color="#777777">
                Service means the{' '}
                <a href="https://www.greenchoicenow.com" target="_blank" rel="noopener noreferrer">
                  https://www.greenchoicenow.com
                </a>{' '}
                website and the GreenChoice mobile application operated by GreenChoice, PBC
              </XMText>
            </li>
            <li>
              <XMText fontWeight="600" padding="0 0 6px 0" color="#777777">
                Personal Data
              </XMText>
              <XMText color="#777777">
                Personal Data means data about a living individual who can be identified from those data (or from those
                and other information either in our possession or likely to come into our possession).
              </XMText>
            </li>
            <li>
              <XMText fontWeight="600" padding="0 0 6px 0" color="#777777">
                Usage Data
              </XMText>
              <XMText color="#777777">
                For more information on the privacy practices of Google, please visit the Google Privacy & Terms web
                page:{' '}
                <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy?hl=en
                </a>{' '}
              </XMText>
            </li>
            <li>
              <XMText fontWeight="600" padding="0 0 6px 0" color="#777777">
                Mixpanel
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                Mix panel is provided by Mixpanel Inc.
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                You can prevent Mixpanel from using your information for analytics purposes by opting-out. To opt-out of
                Mixpanel service, please visit this page:{' '}
                <a href="https://mixpanel.com/optout/" target="_blank" rel="noopener noreferrer">
                  https://mixpanel.com/optout/
                </a>{' '}
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                For more information on what type of information Mixpanel collects, please visit the Terms of Use page
                of Mixpanel:{' '}
                <a href=" https://mixpanel.com/terms/" target="_blank" rel="noopener noreferrer">
                  https://mixpanel.com/terms/
                </a>{' '}
              </XMText>
            </li>
          </Ul>

          <DefaultText color="#124b5f">Behavioural Remarking</DefaultText>
          <XMText color="#777777">
            GreenChoice, PBC uses remarking services to advertise on third party websites to you after you visited our
            Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past
            visits to our Service.
          </XMText>
          <Ul>
            <li>
              <XMText fontWeight="600" padding="0 0 6px 0" color="#777777">
                Google Ads (AdWords)
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                Google Ads (AdWords) remarking service is provided by Google Inc.
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                You can opt-out of Google Analytics for Display Advertising and customise the Google Display Network ads
                by visiting the Google Ads Settings page:{' '}
                <a href="http://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
                  http://www.google.com/settings/ads
                </a>{' '}
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                Google also recommends installing the Google Analytics Opt-out Browser Add-on -{' '}
                <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
                  https://tools.google.com/dlpage/gaoptout
                </a>{' '}
                - for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to
                prevent their data from being collected and used by Google Analytics.
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                For more information on the privacy practices of Google, please visit the Google Privacy & Terms web
                page:{' '}
                <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy?hl=en
                </a>{' '}
              </XMText>
            </li>
            <li>
              <XMText fontWeight="600" padding="0 0 6px 0" color="#777777">
                Facebook
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                Facebook remarking service is provided by Facebook Inc.
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                You can learn more about interest-based advertising from Facebook by visiting this page:{' '}
                <a href="https://www.facebook.com/help/164968693837950" target="_blank" rel="noopener noreferrer">
                  https://www.facebook.com/help/164968693837950
                </a>{' '}
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                To opt-out from Facebook’s interest-based ads, follow these instructions from Facebook:{' '}
                <a href="https://www.facebook.com/help/568137493302217" target="_blank" rel="noopener noreferrer">
                  https://www.facebook.com/help/568137493302217
                </a>{' '}
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the
                Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies{' '}
                <a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">
                  http://www.aboutads.info/choices/
                </a>{' '}
                through the Digital Advertising Alliance in the USA , the Digital{' '}
                <a href="http://youradchoices.ca/" target="_blank" rel="noopener noreferrer">
                  http://youradchoices.ca/
                </a>{' '}
                Advertising Alliance of Canada in Canada or the European Interactive Digital{' '}
                <a href="http://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer">
                  http://www.youronlinechoices.eu/
                </a>{' '}
                Advertising Alliance in Europe , or opt-out using your mobile device settings.
              </XMText>
              <XMText color="#777777" padding="0 0 6px 0">
                For more information on the privacy practices of Facebook, please visit Facebook’s Data Policy:{' '}
                <a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer">
                  https://www.facebook.com/privacy/explanation
                </a>{' '}
              </XMText>
            </li>
          </Ul>
          <XXLText textAlign="left" color="#124b5f">
            Links to Other Sites
          </XXLText>
          <XMText color="#777" padding="0 0 10px 0">
            Our Service may contain links to other sites that are not operated by us. If you click a third party link,
            you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of
            every site you visit.
          </XMText>
          <XMText color="#777" padding="0 0 10px 0">
            We have no control over and assume no responsibility for the content, privacy policies or practices of any
            third party sites or services.
          </XMText>
          <XXLText textAlign="left" color="#124b5f">
            Children’s Privacy
          </XXLText>
          <XMText color="#777" padding="0 0 10px 0">
            Our Service does not address anyone under the age of 18 (“Children”).
          </XMText>
          <XMText color="#777" padding="0 0 10px 0">
            We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are
            a parent or guardian and you are aware that your Child has provided us with Personal Data, please contact
            us. If we become aware that we have collected Personal Data from children without verification of parental
            consent, we take steps to remove that information from our servers.
          </XMText>
          <XXLText textAlign="left" color="#124b5f">
            Changes to This Privacy Policy
          </XXLText>
          <XMText color="#777" padding="0 0 10px 0">
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new
            Privacy Policy on this page.
          </XMText>
          <XMText color="#777" padding="0 0 10px 0">
            We will let you know via email and/or a prominent notice on our Service, prior to the change becoming
            effective and update the “effective date” at the top of this Privacy Policy.
          </XMText>
          <XMText color="#777" padding="0 0 10px 0">
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy
            are effective when they are posted on this page.
          </XMText>

          <XXLText textAlign="left" color="#124b5f">
            Contact Us
          </XXLText>
          <XMText color="#777" padding="0 0 10px 0">
            If you have any questions about this Privacy Policy, please contact us:
          </XMText>
          <Ul>
            <li>
              <XMText color="#777777">
                By email:{' '}
                <a href="mailto:contactus@greenchoicenow.com?Subject=Hello" target="_top">
                  contactus@greenchoicenow.com
                </a>{' '}
                website and the GreenChoice mobile application operated by GreenChoice, PBC
              </XMText>
              <XMText color="#777777">
                By visiting this page on our website:{' '}
                <a href="https://www.greenchoicenow.com/connect" target="_blank" rel="noopener noreferrer">
                  https://www.greenchoicenow.com/connect
                </a>{' '}
              </XMText>
              <XMText color="#777777">
                By phone number: <a href="tel:617-855-9025">617-855-9025</a>{' '}
              </XMText>
            </li>
          </Ul>
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/pages/PrivacyPolicy.js